import { useEffect, useState } from "react";

import { IPlantDTO } from "@interfaces/IPlantDTO";
import { getInvoices } from "@service/invoiceApiService";
import Spinner from "@components/Spinner";

interface IInvoiceSummaryProps {
  plants: IPlantDTO[];
}

export function InvoiceCurrentPeriod({ plants }: IInvoiceSummaryProps): JSX.Element {
  const [selectedPlantId, setSelectedPlantId] = useState(-1);
  const [isLoading, setIsLoading] = useState(true);
  const [invoices, setInvoices] = useState({});

  useEffect(() => {
    const selected = plants && plants.length > 0 ? plants[0] : null;
    setSelectedPlantId(selected?.id ?? -1);
  }, [plants]);

  useEffect(() => {
    async function fetchPlants() {
        try {
          const response = await getInvoices();
          setInvoices(response);
          setIsLoading(false);
          setInvoices(response ?? []);
           
        } catch (error) {
          setIsLoading(false);
          console.error('Error fetching plants:', error);
        }
    }
    fetchPlants();
  }, []);

  function handleChangePlant(id: number) {
    setSelectedPlantId(id);
  }

  return (
    <>
      <div className="tw-flex tw-mb-2 tw-h-[65vh]">
        <div className="tw-flex tw-min-w-[580px] tw-flex-col">
          <h4 className="Subheader tw-mb-3">Current Invoice Period</h4>
          <div className="tw-flex tw-flex-row tw-items-start tw-mb-5 tw-ml-4 tw-mt-2 ">
            <div className="tw-flex tw-flex-col tw-max-h-[60vh] tw-overflow-y-auto tw-overflow-x-hidden">
              <table className="tw-min-w-[270px]">
                <thead>
                  <tr>
                    <th className="tw-p-2 tw-text-left">Plant</th>
                  </tr>
                </thead>
              </table>
              <table className="tw-min-w-[270px]">
                <tbody>
                  {plants.map((plant) => (
                    <tr key={plant.id}>
                      <td
                        className={`tw-text-left tw-min-w-[280px] hover:tw-bg-blue-100 ${selectedPlantId === plant.id ? 'tw-bg-blue-100' : ''}`}
                        onClick={() => handleChangePlant(plant.id ?? -1)}
                        >
                        {plant.name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {isLoading ? (
              <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-min-w-[580px] tw-min-h-[55vh]">
                <Spinner className="tw-flex tw-justify-center tw-ml-2 tw-items-center tw-w-full"/>
                Loading invoices...
              </div>
            ) : (
              <div>
                {/* <table >
                  
                </table> */}
                <div className="tw-max-h-[55vh] tw-overflow-y-auto tw-ml-10 ">
                  <table className="tw-w-full">
                    <thead>
                    <tr>
                      <th className="tw-sticky tw-top-0 z-10">ID</th>
                      <th className="tw-sticky tw-top-0 z-10">Name</th>
                      <th className="tw-sticky tw-top-0 z-10">REGHRS</th>
                      <th className="tw-sticky tw-top-0 z-10">OTHRS</th>
                      <th className="tw-sticky tw-top-0 z-10">PTO</th>
                      <th className="tw-sticky tw-top-0 z-10">HOLIDAY</th>
                      <th className="tw-sticky tw-top-0 z-10">RATE</th>
                      <th className="tw-sticky tw-top-0 z-10">OTRATE</th>
                      <th className="tw-sticky tw-top-0 z-10">TOTAL</th>
                    </tr>
                  </thead>
                    <tbody>
                      {
                        Object.entries(invoices).map(([key, plantObj]) =>
                          Object.entries(plantObj as object).map(([, employeees], idx2) => {
                            if (typeof employeees !== 'string' && employeees !== null && key === selectedPlantId.toString()) {
                              return Object.entries(employeees as object).map(([, contractor], idx3) => (
                                <tr key={`${key}-${idx2}-${idx3}`}>
                                  <td>{contractor.contractor_id }</td>
                                  <td className="tw-truncate tw-max-w-[11rem] tw-overflow-hidden tw-whitespace-nowrap">{contractor.name }</td>
                                  <td>{contractor.regular }</td>
                                  <td>{contractor.overtime }</td>
                                  <td>{contractor.pto }</td>
                                  <td>{contractor.holiday }</td>
                                  <td>{contractor.rate }</td>
                                  <td>{contractor.over_rate }</td>
                                  <td>{contractor.total }</td>
                                </tr>
                              ));
                            }
                            return null;
                          })
                        )
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}